import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import UpIcon from '@mui/icons-material/ArrowDropUp';
import DownIcon from '@mui/icons-material/ArrowDropDown';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

import { FlightListPrice_flight$key } from '__generated__/FlightListPrice_flight.graphql';

type Props = {
  flight: FlightListPrice_flight$key;
};

const arrow = (current: number, last: number) => {
  if (current > last) {
    return (
      <UpIcon
        sx={{ verticalAlign: 'middle', color: 'error.main', fontSize: 40 }}
      />
    );
  }

  if (current < last) {
    return (
      <DownIcon
        sx={{ verticalAlign: 'middle', color: 'success.main', fontSize: 40 }}
      />
    );
  }

  return <Box sx={{ width: 40, display: 'inline-block' }} />;
};

const FlightListPrice: FC<Props> = ({ flight }) => {
  const { priceLive, lastPriceLive } = useFragment(
    graphql`
      fragment FlightListPrice_flight on Flight {
        priceLive
        lastPriceLive
      }
    `,
    flight
  );

  return (
    <Box>
      {priceLive !== lastPriceLive ? (
        <Tooltip title={`Buvo ${lastPriceLive}`}>
          <Box component="span">€{priceLive}</Box>
        </Tooltip>
      ) : (
        `€${priceLive}`
      )}

      {arrow(priceLive, lastPriceLive)}
    </Box>
  );
};

export default FlightListPrice;
